import React from 'react';
import Card from 'components/Card/Card';
import CardBody from 'components/Card/CardBody';
import { HeadingLBold, BodyM } from 'components/Typography/Typography';
import { translate } from 'components/Translation';
import Button from 'components/CustomButtons/Button';
import { makeStyles } from '@material-ui/core';
import styles from 'assets/jss/material-dashboard-pro-react/views/prepaidLoyalty/emptyCardStyle';
import TopUpIcon from 'assets/img/icons/top-up-img-small.svg';
import Add from '@material-ui/icons/Add';
import VerticalAlignBottomSharpIcon from '@material-ui/icons/VerticalAlignBottomSharp';
import CanPerform from 'components/CanPerform/CanPerform';

// @ts-ignore
const useStyles = makeStyles(styles);

interface IEmptyCard {
	showAddNumbersDialog: () => void;
	showUploadNumbersFromFileDialog: () => void;
}

const EmptyCard = ({ showAddNumbersDialog, showUploadNumbersFromFileDialog }: IEmptyCard) => {
	const classes = useStyles();

	return (
		<Card className={classes.card}>
			<CardBody>
				<img alt="Empty card icon" src={TopUpIcon} className={classes.image} />
				<HeadingLBold>{translate('prepaid.loyalty.create.loyalty')}</HeadingLBold>
				<CanPerform
					action="prepaid-loyalty:add-numbers-buttons-description"
					yes={
						<>
							<div className={classes.descriptionWrapper}>
								<BodyM disableMargin>{translate('prepaid.loyalty.create.loyalty.description')}</BodyM>
							</div>
							<div className={classes.buttonsWrapper}>
								<Button color="primary-light" onClick={showAddNumbersDialog} withIcon>
									<>
										<Add />
										{translate('prepaid.loyalty.add.numbers')}
									</>
								</Button>
								<Button color="tertiary-light" onClick={showUploadNumbersFromFileDialog} withIcon>
									<>
										<VerticalAlignBottomSharpIcon />
										{translate('prepaid.loyalty.upload')}
									</>
								</Button>
							</div>
						</>
					}
					no={
						<div className={classes.descriptionWrapper}>
							<BodyM disableMargin>
								{translate('prepaid.loyalty.create.loyalty.description.no.permission')}
							</BodyM>
							<BodyM disableMargin>
								{translate('prepaid.loyalty.create.loyalty.description.no.permission2')}
							</BodyM>
						</div>
					}
				/>
			</CardBody>
		</Card>
	);
};

export default EmptyCard;
